import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import WaitingContactTable from '../components/WaitingContactTable';

const i18nPrefix = 'WaitingContactTable';

class WaitingContact extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <Container style={{ maxHeight: 'none', backgroundColor: 'white' }}>
          <Row>
            <Col sm={4}>
              <div style={{ overflow: 'hidden' }}>
                <h1 style={{ float: 'left' }}>
                  {t(`${i18nPrefix}.waitingQueue`)}
                </h1>
              </div>
            </Col>
          </Row>

          <WaitingContactTable />
        </Container>
      </>
    );
  }
}

export default withTranslation()(WaitingContact);
